export default __webpack_public_path__ + "static/media/Baghela-Museum-2.4ce82909.jpg";